import { Lightbulb } from "lucide-react";

/**
 * Business Impact Narratives Component
 * 
 * Displays three executive-level insight blocks:
 * 1. Operational Reality
 * 2. Decision Context  
 * 3. Opportunity Perspective
 */
const BusinessImpactNarratives = ({ narratives }) => {
  if (!narratives || narratives.length === 0) return null;

  const iconColors = {
    "Operational Reality": "bg-blue-500/20 text-blue-400",
    "Decision Context": "bg-amber-500/20 text-amber-400",
    "Opportunity Perspective": "bg-green-500/20 text-green-400"
  };

  return (
    <div className="w-full" data-testid="business-impact-narratives">
      <div className="mb-6">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Lightbulb className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h2 className="font-heading text-xl font-semibold text-white">
              Business Impact Analysis
            </h2>
            <p className="text-slate-400 text-sm">
              Executive insights derived from your evaluation data
            </p>
          </div>
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-3">
        {narratives.map((narrative, idx) => (
          <div 
            key={idx}
            className="bg-navy-950/50 rounded-xl p-5 border border-slate-700/50 hover:border-slate-600 transition-colors"
          >
            <div className="flex items-center gap-2 mb-3">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${iconColors[narrative.title] || 'bg-slate-500/20 text-slate-400'}`}>
                <span className="font-heading font-bold text-sm">{idx + 1}</span>
              </div>
              <h3 className="font-heading font-semibold text-white text-sm">
                {narrative.title}
              </h3>
            </div>
            <p className="text-slate-300 text-sm leading-relaxed">
              {narrative.insight}
            </p>
          </div>
        ))}
      </div>

      {/* Print version - more compact */}
      <div className="hidden print:block">
        <div className="space-y-3">
          {narratives.map((narrative, idx) => (
            <div key={idx} className="border-l-2 border-primary/50 pl-4">
              <p className="text-primary text-xs font-medium uppercase tracking-wider">
                {narrative.title}
              </p>
              <p className="text-slate-700 text-sm leading-relaxed mt-1">
                {narrative.insight}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BusinessImpactNarratives;
